const getRollingCoins = async (currency) => {
  return await fetch(
    //`https://us-central1-zefi-cms.cloudfunctions.net/getRollingCoins/en`,
    `https://api.coingecko.com/api/v3/coins/markets?vs_currency=${currency}&order=market_cap_desc&per_page=72&page=1&sparkline=false`,
    // "https://api.coingecko.com/api/v3/coins/markets?vs_currency=aed&order=market_cap_desc&per_page=72&page=1&sparkline=false",
    { method: "GET" }
  )
    .then((res) => res.json())
    .then((json) => {
      // console.log("getRollingCoins(): ", json);
      return json;
    })
    .catch((error) => {
      console.log(error);
      return undefined;
    });
};

export { getRollingCoins };
